import Button from "@mui/material/Button";
import React from "react";
import copilotIcon from "../assets/img/copilotIcon.svg";
import {
  CopilotWorkflow,
  useCopilotStore,
} from "../store/copilot/CopilotStore";
import { ConfirmationDialog } from "./Dialog/ConfirmationDialog";

interface CopilotButtonProps {
  disabled?: boolean;
  workflow: CopilotWorkflow;
  id?: string;
}

const CopilotButton: React.FC<CopilotButtonProps> = ({
  disabled = false,
  workflow,
  id,
}) => {
  const {
    showCopilot,
    hideCopilot,
    workflow: copilotWorkflow,
  } = useCopilotStore();
  const [modalOpen, setModalOpen] = React.useState(false);

  const isCopilotOpen = Boolean(copilotWorkflow);

  const handleClick = () => {
    if (isCopilotOpen) {
      setModalOpen(true);
    } else {
      showCopilot(workflow);
    }
  };

  const handleDialogOnClose = () => {
    setModalOpen(false);
  };

  const handleDialogOConfirm = () => {
    hideCopilot();
    showCopilot(workflow);
    setModalOpen(false);
  };

  return (
    <>
      <Button
        id={id}
        onClick={handleClick}
        disabled={disabled}
        variant="outlined"
        sx={{
          minWidth: "30px",
          width: "30px",
          height: "30px",
          padding: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderColor: "#5e35b1",
          color: "#5e35b1",
          borderRadius: "4px",
          "&:hover": {
            borderColor: "#5e35b1",
            background: "#ede7f6",
          },
        }}
      >
        <img
          src={copilotIcon}
          alt="Copilot"
          style={{
            display: "block",
            margin: "0 auto",
            width: "18px",
            height: "18px",
          }}
        />
      </Button>
      <ConfirmationDialog
        open={modalOpen}
        title="Copilot Alert"
        description="You have a chat going on. Do you want start a new one?"
        okayButtonText="yes"
        onClose={handleDialogOnClose}
        onConfirm={handleDialogOConfirm}
      />
    </>
  );
};

export default CopilotButton;
